import {
  createTransactionWithToken as createTransactionWithTokenApi,
  requestTransactionStatusWithToken as requestTransactionStatusWithTokenApi
} from '../api/idin'
import { IUser } from '../models/user'
import { setIdinResultStatus } from '../state/slices/idin_slice'
import { useAppDispatch } from './state'

export const useIdin = () => {
  const dispatch = useAppDispatch()

  const createTransactionWithToken = async (
    token: string,
    email: string
  ) => {
    try {
      return await createTransactionWithTokenApi(
        token,
        email
      )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(setIdinResultStatus(error?.data?.error || 'generic_error'))

      throw new Error(
        error.message || 'Er is iets misgegaan bij het aanmaken van de iDIN transactie. Probeer het later opnieuw.'
      )
    }
  }

  const requestTransactionStatusWithToken = async (
    token: string,
    email: string
  ) => {
    try {
      const data = await requestTransactionStatusWithTokenApi(
        token,
        email
      )

      if (data.user && data.token) {
        return {
          user: data.user as IUser,
          token: data.token.token,
          success: true
        }
      }

      throw new Error(
        'Er is iets misgegaan bij het aanmaken van de iDIN transactie. Probeer het later opnieuw.'
      )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(setIdinResultStatus(error?.data?.error || 'generic_error'))

      throw new Error(
        error.message || 'Er is iets misgegaan bij het aanmaken van de iDIN transactie. Probeer het later opnieuw.'
      )
    }
  }

  return {
    createTransactionWithToken,
    requestTransactionStatusWithToken
  }
}

export default useIdin
